import React, { createContext, useState } from "react";
import * as Constants from '../Common/CommonConstants';
import { getDataByCode,getFormListByCode } from '../../services/dataService';

const QuestionnaireCodeContext = createContext([{}, () => { }]);

const QuestionnaireCodeProvider = (props) => {
  const [formState, setFormState] = useState(Constants.ENTER_KEY_MODE);
  const [doneMessage, setDoneMessage] = useState({ message: "", subMessage: "" });
  const [key1, setKey1] = useState("");
  const [key2, setKey2] = useState("");
  const [error, setError] = useState(0);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(null);
  const [formList, setFormList] = useState([]);


  const setCompleteState = (props) => {
    setFormState(Constants.DONE_MODE);
    setDoneMessage({ message: "Form Completed Successfully", subMessage: "" });
  }

  const updateFormState = (formWasSaved) => {
    if (formState === Constants.READ_ONLY_MODE) {
      setFormState(Constants.DONE_MODE);
      setDoneMessage({ message: "", doneSubMessage: "" })
    }
    else if (formWasSaved) {
      setFormState(Constants.DONE_MODE);
      setDoneMessage({ message: "Form was not saved", doneSubMessage: "" })
    }
    else {
      setFormState(Constants.DONE_MODE);
      setDoneMessage({ message: "Form Saved Successfully", doneSubMessage: "(but not completed)" })
    }
  }


  const openForm = async () => {

    setError(0);
    setLoading(true);

    try {
      var result = await getDataByCode(key1, key2);
      if (result.data.formInfo.status === "COMPLETE")
        setFormState(Constants.READ_ONLY_MODE);
      else
        setFormState(Constants.EDIT_MODE);

      setFormData(result.data);
    }

    catch (e) {
      var errorObj = e;      
      setError(errorObj.request.status);

    }
    finally {
      setLoading(false);
    }

  }

  const openPortal = async () => {
    setError(0);
    setLoading(true);

    try {
      var result = await getFormListByCode(key1, key2);
      setFormState(Constants.PORTAL_MODE);

      setFormList(result.data);
    }

    catch (e) {
      setError(e.request.status);

    }
    finally {
      setLoading(false);
    }
   
  }


  return (
    <QuestionnaireCodeContext.Provider value={{ formState, updateFormState, doneMessage, setDoneMessage, key1, setKey1, key2, setKey2, openForm, openPortal, formData, setCompleteState, setLoading, loading, formList, error }}>
      {props.children}
    </QuestionnaireCodeContext.Provider>
  )
}

export { QuestionnaireCodeContext, QuestionnaireCodeProvider };